import React from 'react';
import RankBox from './RankBox';
import { LaborForceAndUnemploymentChart, IndustryJobsChart } from './charts/LaborCharts';
import { lausRatesData, industryJobsData } from './api/laborData';
import { laborForce , employment } from './api/rankBoxes';

const LaborView = () => {

  return (
    <>
      <div className="flex flex-wrap justify-center mb-8">
          <RankBox 
            title="Labor Force Growth" 
            value={laborForce.value} 
            type="percent" 
            rank={laborForce.rank}
            trend={laborForce.trend}
          />
          <RankBox
            title="Employment Growth (1Yr)"
            value={employment.value}
            type="percent"
            rank={employment.rank}
            trend={employment.trend}
            />
      </div>
      
      <div className="bg-white p-4 rounded-lg shadow mb-8">
        <h2 className="text-xl font-semibold mb-4">Labor Force and Unemployment Rates</h2>
        <LaborForceAndUnemploymentChart data={lausRatesData} />
      </div>

      <div className="bg-white p-4 rounded-lg shadow mb-8">
        <h2 className="text-xl font-semibold mb-4">Industry Employment Index</h2>
        <IndustryJobsChart data={industryJobsData} />
      </div>
    </>
  );
};

export default LaborView;